var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNat23(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.441,
    height: 79.634,
    viewBox: "0 0 58.441 79.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34353",
    "data-name": "Group 34353",
    transform: "translate(-201.25 -522.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32488",
    "data-name": "Group 32488",
    transform: "translate(203 524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26734",
    "data-name": "Path 26734",
    d: "M4009.478,2544.559v10.229l15.657,10.982v39.259h-54.941V2565.77l15.657-10.982v-10.229",
    transform: "translate(-3970.195 -2528.896)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26735",
    "data-name": "Path 26735",
    d: "M3991.41,2505.743h37.819v15.664H3991.41v-5.914",
    transform: "translate(-3982.849 -2505.743)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26736",
    "data-name": "Path 26736",
    d: "M3994.82,2612.175h35.856v21.753H3994.82",
    transform: "translate(-3984.883 -2569.226)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x2: 17.65,
    transform: "translate(19.04 53.825)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x1: 13.453,
    transform: "translate(25.83 25.893)",
    fill: "none",
    stroke: "#ffd748",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNat23);
export default __webpack_public_path__ + "static/media/nat2-3.99fdb1915ec16caa39f00fb3b068a519.svg";
export { ForwardRef as ReactComponent };